export default "__VITE_ASSET__Dh9gn63t__"